module.exports = __webpack_public_path__ + "img/logo.c73a559a.png";